import React, { useState } from 'react';
import { AddOn, Customer, QuestionnaireTemplate, Service, SystemConfig, User } from '@/types';
import { CustomerList } from './CustomerList';
import { CustomerEditor } from './CustomerEditor';
import { CustomerDetailPanel } from './CustomerDetailPanel';

interface CustomersTabProps {
  services?: Service[];
  addOns?: AddOn[];
  questionnaires?: QuestionnaireTemplate[];
  currentUser?: User;
  canEdit: boolean;
  canRevokeCertificate?: boolean;
  canOverrideLockedPaperwork?: boolean;
  canEditCertificate?: boolean;
  targetCustomerId: string | null;
  targetCustomerSearch: string | null;
  onClearTargetCustomer: () => void;
  onClearTargetCustomerSearch: () => void;
  systemConfig?: SystemConfig;
}

export const CustomersTab: React.FC<CustomersTabProps> = ({
  services = [],
  addOns = [],
  questionnaires = [],
  currentUser,
  canEdit,
  canRevokeCertificate = false,
  canOverrideLockedPaperwork = false,
  canEditCertificate = false,
  targetCustomerId,
  targetCustomerSearch,
  onClearTargetCustomer,
  onClearTargetCustomerSearch,
  systemConfig
}) => {
  const [selectedCustomer, setSelectedCustomer] = useState<Customer | null>(null);
  const [editingCustomer, setEditingCustomer] = useState<Customer | null>(null);

  const handleSelect = (customer: Customer) => {
    setSelectedCustomer(customer);
  };

  const handleClose = () => {
    setSelectedCustomer(null);
    onClearTargetCustomer();
  };

  return (
    <div className="animate-fade-in h-[calc(100vh-200px)] flex flex-col">
      {editingCustomer && (
        <CustomerEditor
          customer={editingCustomer}
          onSaved={(updated) => {
            setSelectedCustomer(updated);
            setEditingCustomer(null);
          }}
          onClose={() => setEditingCustomer(null)}
        />
      )}

      {selectedCustomer ? (
        <CustomerDetailPanel
          customer={selectedCustomer}
          services={services}
          addOns={addOns}
          questionnaires={questionnaires}
          systemConfig={systemConfig}
          currentUser={currentUser}
          canEdit={canEdit}
          canRevokeCertificate={canRevokeCertificate}
          canOverrideLockedPaperwork={canOverrideLockedPaperwork}
          canEditCertificate={canEditCertificate}
          onEdit={() =>
            setEditingCustomer({
              ...selectedCustomer
            })
          }
          onClose={handleClose}
        />
      ) : (
        <CustomerList
          targetCustomerId={targetCustomerId}
          targetSearch={targetCustomerSearch}
          onSelect={handleSelect}
          onClearTarget={onClearTargetCustomer}
          onClearTargetSearch={onClearTargetCustomerSearch}
        />
      )}
    </div>
  );
};
